import { stringify } from 'querystring';
import { createAction, createApiAction, createErrorAction } from '@saucelabs/sl-util-redux';
import { replace, push } from 'connected-react-router';

import * as types from './types';
import * as util from './../../util';
import * as api from './../general/api';
import * as commonApi from '../common/api';

// push a new location to the history
export const pushPath = (pathname, params) => push({ pathname, search: `?${stringify(params)}` });

// read location from meta and replace queryString if location exists
export const handleLocationMeta = (action, getNewQueryParam) => (payload, meta) => (dispatch) => {
  const location = meta?.location || null;
  const newQueryParams = location ? getNewQueryParam(location, payload) : null;
  const routeChangeMethod = location?.action === 'push' ? push : replace;

  if (payload === null) {
    util.clearStoredFilters(location.pathname);
  } else if (newQueryParams) {
    util.storeFilters(newQueryParams, location.pathname);
  }

  return Promise.all([
    dispatch(action(payload, meta)),
    ...(newQueryParams ?
      [dispatch(routeChangeMethod({ pathname: location.pathname, search: `?${stringify(newQueryParams)}` }))] : []),
  ]);
};

export const clearSelectedFilters = handleLocationMeta(
  createAction(types.CLEAR_SELECTED_FILTERS), util.clearSelectedFilterTransformer);

export const selectDateFilter = handleLocationMeta(
  createAction(types.SELECT_DATE_FILTER), util.selectedDateTransformer);

export const selectFilterItems = handleLocationMeta(
  createAction(types.SELECT_FILTER_ITEMS), util.selectFilterTransformer);

export const setFiltersFromQueryParams = createAction(types.SET_FILTERS_FROM_QUERY_PARAMS);

export const setFilterItems = createAction(types.SET_FILTER_ITEMS);

export const removeFilterItem = handleLocationMeta(
  createAction(types.REMOVE_FILTER_ITEM), util.removeFilterTransformer);

export const addOrganization = createAction(types.ADD_ORGANIZATION);
export const addUsername = createAction(types.ADD_USERNAME);
export const addTeam = createAction(types.ADD_TEAM);
export const fetchOwnersRequest = createAction(types.FETCH_OWNERS.REQUEST);
export const fetchOwnersSuccess = createAction(types.FETCH_OWNERS.SUCCESS);
export const searchMetadataRequest = createAction(types.SEARCH_METADATA.REQUEST);
export const searchMetadataSuccess = createAction(types.SEARCH_METADATA.SUCCESS);
export const searchMetadataFailure = createErrorAction(types.SEARCH_METADATA.FAILURE);

export const fetchOwnersFiltered = createApiAction(
  types.FETCH_OWNERS_FILTERED,
  ({ queryParams = {}, ...params } = {}) => (
    commonApi.fetchUsers(queryParams)
      .then(({ data }) => ({ ...data, ...params }))
  ),
  { meta: { skipErrorPage: true } },
);

export const getOrganizationUsers = createApiAction(
  types.GET_ORGANIZATION_USERS,
  (payload) => api.getUsers(payload),
  { meta: { skipErrorPage: true } },
);

export const getTeams = createApiAction(
  types.GET_TEAMS,
  (payload) => api.getTeams(payload),
  { meta: { skipErrorPage: true } },
);
